import UserManagementTable from "./UserManagementTable";

const UserManagement = ({ children }) => {
  return <UserManagementTable />;
};
export default UserManagement;
